import { FacilityFactory } from './facilityFactory';

import type {
  FacilityEntity,
  FacilityPropsPub,
  FacilityPropsPvt,
} from './facilityEntity';
import type { FacilityIRepository } from './facilityIRepository';
import type { EntityDataPubType } from '@/infra/appsync';
import type { FacilityJsonPub, FacilityJsonPvt } from '@/types/domain/childApply/entities/facilityEntity';

import { AppsyncRepository } from '@/domain/appsyncRepository';
import {
  EntityName,
} from '@/infra/appsync';

export class FacilityRepository extends AppsyncRepository<
  FacilityEntity,
  FacilityPropsPvt,
  FacilityJsonPvt,
  FacilityPropsPub,
  FacilityJsonPub
> implements FacilityIRepository {
  private factory = new FacilityFactory();

  protected get entityName(): EntityName {
    const name: EntityName = EntityName.WagakoAppChildApplyFacilityEntity;
    return name;
  }

  /**
   * DBデータをEntityに変換
   * @param props DBデータ
   * @returns Entity
   */
  protected createFromEntityType = (
    props: EntityDataPubType,
  ) => this.factory.createFromEntityType(props);
}
